import FirstStep from './firstStep'
import SecondStep from './secondStep'

export const steps = [FirstStep, SecondStep]
